import { StyleSheet } from 'aphrodite';

import Circle0 from './0.png';
import Circle10 from './10.png';
import Circle20 from './20.png';
import Circle30 from './30.png';
import Circle40 from './40.png';
import Circle50 from './50.png';
import Circle60 from './60.png';
import Circle70 from './70.png';
import Circle80 from './80.png';
import Circle90 from './90.png';
import Circle100 from './100.png';

const ScoreCircles = {
  imageStyleSheetForFactor: function(factor) {
    const sourceFiles = [Circle0, Circle10, Circle20, Circle30, Circle40, Circle50, Circle60, Circle70, Circle80, Circle90, Circle100];
    var sourceFile;
    // Clamp to 0 and 100%, ensure that the extremes of the range round inward, and otherwise round normally.
    // up to the closest 10%
    if (factor <= 0.) {
      sourceFile = sourceFiles[0];
    } else if (factor <= 0.05) {
      sourceFile = sourceFiles[1];
    } else if (factor >= 1.) {
      sourceFile = sourceFiles[10];
    } else if (factor >= 0.95) {
      sourceFile = sourceFiles[9];
    } else {
      sourceFile = sourceFiles[Math.round(factor*10)];
    }
    return StyleSheet.create({
      image: {
        backgroundImage: `url(${sourceFile})`
      }
    });
  }
}

export default ScoreCircles;



// WEBPACK FOOTER //
// ./src/scoreCircles/ScoreCircles.js